import { useCallback } from "react";

import { useTranslation } from "react-i18next";
import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils.ts";

const errorSchema = z.object({
  error: z.string(),
  data: cz.optional(z.record(z.string(), z.unknown())),
});

export const DEFAULT_ERROR_MAPPING: Record<string, string> = {
  UNKNOWN_ERROR: "errors.unknownErrorFull",
  EMAIL_ALREADY_IN_USE: "errors.emailAlreadyInUse",
};

export const useAPIErrorMessageParser = () => {
  const { t } = useTranslation();

  return useCallback(
    (apiError: unknown, errorMapping?: Record<string, string>): string | undefined => {
      const mergedErrorMapping = {
        ...DEFAULT_ERROR_MAPPING,
        ...(errorMapping ?? {}),
      };
      if (!apiError) {
        return undefined;
      }
      const parsedError = errorSchema.safeParse(apiError);
      if (!parsedError.success) {
        return t(mergedErrorMapping["UNKNOWN_ERROR"]);
      }
      const error = parsedError.data;
      if (!error.error) {
        return undefined;
      }
      if (error.error in mergedErrorMapping) {
        return t(mergedErrorMapping[error.error], error.data);
      } else {
        return t(mergedErrorMapping["UNKNOWN_ERROR"]);
      }
    },
    [t],
  );
};
